const SelectConstants = {
  NUMBERS: {
    MINUS_ONE: -1,
    ZERO: 0,
    ONE: 1
  }
}

export default SelectConstants